module.exports = __webpack_public_path__ + "static/media/p_36_4.1ca61d01.png";